"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Lock.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Lock = function Lock(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 188 201.76"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Lock Icon"), _react2.default.createElement("g", {
    className: "lock",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "lock-2",
    d: "M92.48 0c-33 0-60 25.76-62.67 57.76H0v144h188v-144h-32.85C152.53 25.76 125.43 0 92.48 0zM93 10.78a53.32 53.32 0 0 1 53.14 45H39.82a53.32 53.32 0 0 1 53.18-45zm84 180H11v-123h166v123z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "keyhole",
    d: "M110.54 160.76l-8.91-44.12a15 15 0 0 0 5.07-11.21 14.73 14.73 0 1 0-29.47-.12 15.3 15.3 0 0 0 5.07 11.35l-8.92 44.1h37.15z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = Lock;